// Eg "MY_VALUE" --> "myValue"
export var constantCaseToCamelCase = function(s) {
    return s.split("_").map(function(w, i) {
        return i === 0 ? "".concat(w.toLowerCase()) : "".concat(w.charAt(0).toUpperCase()).concat(w.substring(1).toLowerCase());
    }).join("");
};
// Eg "MY_VALUE" --> "MyValue"
export var constantCaseToPascalCase = function(s) {
    return s.split("_").map(function(w) {
        return "".concat(w.charAt(0).toUpperCase()).concat(w.substring(1).toLowerCase());
    }).join("");
};
// Eg "MY_VALUE" --> "My Value"
export var constantCaseToCapitalizedText = function(s) {
    return s.split("_").map(function(w) {
        return "".concat(w.charAt(0).toUpperCase()).concat(w.substring(1).toLowerCase());
    }).join(" ");
};
// removes all non-alpha numberic characters except "-"
export var stringToAlphaNumbericDash = function(s) {
    return s.replace(/[^a-zA-Z0-9\-]/g, "");
};
// Eg "MY_VALUE" --> "myvalue"
export var anyCaseToLowerCase = function(s) {
    return s.replace(/_/g, "").replace(/-/g, "").toLowerCase();
};
export var equalsCaseInsensitive = function(s1, s2) {
    return s1 === undefined || s2 === undefined ? s1 === undefined === (s2 === undefined) : s1.toUpperCase() === s2.toUpperCase();
};
